import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { PackagePreparerStepper } from '~/components/organisms/PackagePreparerStepper';
import { useNavigate } from '~/components/utils/Navigation';

export type IPrepareAndroidPackagePageProps = {
  appId: string;
  nextUrl?: string;
};

export const PrepareAndroidPackagePage: React.FC<
  IPrepareAndroidPackagePageProps
> = (props) => {
  const { appId, nextUrl } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{t('PrepareAndroidPackagePage.seo.title')}</title>
      </Helmet>

      <Heading
        title={t('PrepareAndroidPackagePage.title')}
        subtitle={t('PrepareAndroidPackagePage.subtitle')}
        previousUrl={`/apps/${appId}/builds/android`}
      />

      <PackagePreparerStepper
        appId={appId}
        onSuccess={() => navigate(nextUrl ?? `/apps/${appId}/builds/android`)}
        platform="android"
      />
    </>
  );
};
